import React from 'react';
import styled from 'styled-components';
import Layout from './Layout';
import { COLOR } from '../theme/constants';
import config from './../config';
import { useDynamicAssetsInBranding } from '@emarketer/componentlibrary';
import { getDataLayerPropsForNotFoundPage } from '../helpers/DataLayerHelper';
import { trimTrailingSlash } from '@emarketer/code-helpers';
import { useUser } from '@emarketer/auth';

const brandingProps = {
  isTransparent: false,
  enablePodRedirection: true,
};

interface NotFoundProps {
  statusCode?: number;
}

// SEO
const pageTitle = `Oops! We can't find that page | EMARKETER`;
const description = `Explore EMARKETER's coverage of the digital marketplace`;
//

const NotFound = ({ statusCode = 404 }: NotFoundProps) => {
  const brandingAssets = useDynamicAssetsInBranding('/forecasts/api/branding');
  const { user } = useUser();
  return (
    <Layout
      width={'full'}
      title={pageTitle}
      brandingProps={brandingProps}
      description={description}
      canonicalUrl={trimTrailingSlash(config.publicPath)}
      brandingAssets={brandingAssets}
      adSlotsConfig={[]}
      dataLayerProps={getDataLayerPropsForNotFoundPage(user.subscriptionTier)}
    >
      <Wrapper>
        <Heading>Oops!</Heading>
        <Text>We can't seem to find the page you're looking for.</Text>
        <Text>Please check the url.</Text>
        {/* currently the way this service is handling bad request always returns statusCode 200
               rest of the NotFound logic is included in the [...slug].tsx file */}
        <Text>Error: {String(statusCode) === '200' ? '404' : statusCode}</Text>
      </Wrapper>
    </Layout>
  );
};

const Wrapper = styled.div`
  min-height: 650px;
  padding-top: 250px;
  width: 350px;
  text-align: left;
  margin: 0 auto;
`;

const Heading = styled.div`
  font-size: 26px;
  padding-bottom: 10px;
  color: ${COLOR.RED};
  font-weight: 900;
  font-style: normal;
`;

const Text = styled.div`
  color: ${COLOR.BLACK};
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  padding-bottom: 10px;
`;

export default NotFound;
